import React from "react";
import { Dialog, List, ListItem, Paper, Slide } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { useTranslation } from "react-i18next";
import "./index.css";

interface IProps {
  isOpen: boolean;
  setIsOpen: any;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MetamaskInstruction: React.FC<IProps> = ({ isOpen, setIsOpen }) => {
  const { t } = useTranslation();
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Dialog
      onClose={handleClose}
      open={isOpen}
      TransitionComponent={Transition}
      fullWidth
    >
      <Paper className="metamask-instruction-paper">
        <div className="metamask-instruction-button-container">
          <a
            href="https://metamask.io/download/"
            target="_blank"
            rel="noreferrer noopener"
            className="MM-link"
          >
            {t("Wallet_Popper_Fetch")}
          </a>
        </div>
        <List>
          <ListItem className="metamask-instruction-list-item">
            {t("Wallet_Popper_Connect_1")}
          </ListItem>
          <ListItem className="metamask-instruction-list-item">
            {t("Wallet_Popper_Connect_2")}
          </ListItem>
          <ListItem className="metamask-instruction-list-item">
            {" "}
            {t("Wallet_Popper_Connect_3")}
          </ListItem>
        </List>
      </Paper>
    </Dialog>
  );
};

export default MetamaskInstruction;
